import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, Button, Grid, Paper, TextField, Typography } from '@mui/material';
import Layout from '../layout/Layout';
import axios from 'axios';
import QRCode from 'react-qr-code';


function Settings(props) {
  const [authOn, setAuthOn] = useState();
  const { usuario } = useParams();
  const [oAuthEnabled, setOAuthEnabled] = useState(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [newSecret, setNewSecret] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`https://backmu.vercel.app/infoUser/user/${usuario}`);
      setAuthOn(response.data.usuario);
    } catch (error) {
      console.error('Error al obtener usuario:', error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, [usuario]);


  useEffect(() => {
    if (authOn) {
      setOAuthEnabled(authOn.Auth_Login_On === 1); // Cambiado a 1 para indicar habilitado
      setNewSecret(authOn.auth_secret || null);
    }
  }, [authOn]);
  console.log(oAuthEnabled)
  const generateSecret = () => {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
    let secret = "";
    for (let i = 0; i < 16; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      secret += charset[randomIndex];
    }
    return secret;
  };

  const updateOAuthStatus = async (enabled, secret = authOn?.auth_secret) => {
    try {
      let secretToUse = secret;
      if (enabled && !secretToUse) {
        secretToUse = generateSecret();
        setNewSecret(secretToUse);
        await axios.post(
          `https://backmu.vercel.app/infoUser/${usuario}/guardar-secret`,
          { auth_secret: secretToUse },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
      }

      const res = await axios.post(
        `https://backmu.vercel.app/infoUser/${usuario}/actualizar-oauth`,
        { enabled },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      return res.data;
    } catch (error) {
      console.error('Error actualizando OAuth:', error);
      throw new Error('Error actualizando estado de OAuth');
    }
  };

  const handleToggleOAuth = async () => {
    setIsLoading(true);
    if (oAuthEnabled) {
      // Si ya está habilitado, pedir código para desactivar
      setShowCodeInput(true);
      setShowQR(false);
      setIsLoading(false);
      return;
    }
    // Si no está habilitado, generar secreto y mostrar QR + input
    try {
      if (!newSecret) {
        const secret = generateSecret();
        setNewSecret(secret);
        await axios.post(
          `https://backmu.vercel.app/infoUser/${usuario}/guardar-secret`,
          { auth_secret: secret },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
      }
      setShowQR(true);
      setShowCodeInput(true);
      setError('');
    } catch (err) {
      setError('Error al generar el código QR');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCodeSubmit = async () => {
    if (!/^\d{6}$/.test(code)) {
      setError('El código debe tener 6 dígitos');
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(`https://backmu.vercel.app/verificarqr`, {
        secretKey: authOn?.auth_secret || newSecret,
        code,
      });
      if (response.data.isValid) {
        if (oAuthEnabled) {
          // Desactivar 2FA
          await updateOAuthStatus(false);
          setOAuthEnabled(false);
          setShowCodeInput(false);
          setShowQR(false);
          setCode('');
          setError('');
        } else {
          // Activar 2FA
          await updateOAuthStatus(true, newSecret);
          setOAuthEnabled(true);
          setShowCodeInput(false);
          setShowQR(false);
          setCode('');
          setError('');
        }
      } else {
        setError('Código incorrecto. Intenta de nuevo.');
      }
    } catch (error) {
      setError('Error en la verificación del código');
    } finally {
      setIsLoading(false);
    }
  };

  const getQRCodeUrl = () => {
    if (!newSecret) return '';
    const issuer = 'MuSerendipia';
    const account = usuario;
    return `otpauth://totp/${encodeURIComponent(issuer)}:${encodeURIComponent(account)}?secret=${newSecret}&issuer=${encodeURIComponent(issuer)}`;
  };

  return (
    <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>
      <Grid style={{ display: 'flex', flexDirection: 'column', gap: 15, marginTop: 10, padding: 15, borderRadius: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: '100%' }}>

        <Paper elevation={3} sx={{ p: props.isMobile ? 1 : 3, width: props.isMobile ? '100%' : '50%', mx: 'auto', mt: props.isMobile ? 0 : 4 }} s>
          <Typography variant="h5" gutterBottom>Configuración de Cuenta</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="body1">Habilitar OAuth</Typography>
            <Button
              variant="contained"
              onClick={handleToggleOAuth}
              disabled={isLoading}
              color="primary"
            >
              {isLoading
                ? oAuthEnabled
                  ? 'Desactivando...'
                  : 'Activando...'
                : oAuthEnabled
                  ? 'Desactivar 2FA'
                  : 'Activar 2FA'}
            </Button>
          </Box>
          {showQR && newSecret && (
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <Typography variant="body2" gutterBottom>
                Escanea este código QR con Google Authenticator o ingresa el código manualmente:
              </Typography>
              <QRCode value={getQRCodeUrl()} size={200} />
              <Typography variant="body2" sx={{ mt: 2, wordBreak: 'break-all' }}>
                Código manual: {newSecret}
              </Typography>
            </Box>
          )}
          {showCodeInput && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2">
                {oAuthEnabled
                  ? 'Ingresa el código para desactivar OAuth:'
                  : 'Ingresa el código del autenticador para activar 2FA:'}
              </Typography>
              <TextField
                label="Código"
                value={code}
                植物
                onChange={(e) => setCode(e.target.value)}
                fullWidth
                size="small"
                sx={{ my: 2 }}
              />
              {error && <Alert severity="error">{error}</Alert>}
              <Button
                variant="contained"
                onClick={handleCodeSubmit}
                disabled={!code || isLoading}
              >
                {isLoading ? 'Verificando...' : 'Confirmar'}
              </Button>
            </Box>
          )}
          <Typography variant="body2" color="text.secondary">
            {oAuthEnabled ? 'OAuth está habilitado.' : 'OAuth está desactivado.'}
          </Typography>
        </Paper>
      </Grid>

    </Layout>
  );
}

export default Settings;